// Token handling for the auth entry screens. The SPA reads these at call time
// (not as module-load constants like the legacy frontend) so values never go
// stale across in-app navigations. Keys match the rest of the app: "tk" holds
// the JWT, "rmbTk" holds the remember-this-browser token.
const TOKEN_KEY = "tk";
const REMEMBER_ME_KEY = "rmbTk";

const getItemFromStore = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || null;
  } catch (e) {
    localStorage.removeItem(key);
    return null;
  }
};

const setItemToStore = (key, payload) =>
  localStorage.setItem(key, JSON.stringify(payload));

export const getStoredToken = () => getItemFromStore(TOKEN_KEY);

export const getRememberMeToken = () => getItemFromStore(REMEMBER_ME_KEY);

export const setToken = (newToken) => setItemToStore(TOKEN_KEY, newToken);

export const setRememberMeToken = (newToken) =>
  setItemToStore(REMEMBER_ME_KEY, newToken);

export const removeRememberMeToken = () =>
  localStorage.removeItem(REMEMBER_ME_KEY);

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem("current_school_slug");
};

export const parseJwt = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join("")
  );

  return JSON.parse(jsonPayload);
};

// A token whose `exp` claim has passed (or that cannot be parsed) is treated as
// expired. Used so the login screen never bounces on a dead token the server
// will reject anyway.
export const isTokenExpired = (token) => {
  try {
    const { exp } = parseJwt(token);
    if (!exp) return false;
    return exp * 1000 <= Date.now();
  } catch (e) {
    return true;
  }
};
